var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlphabet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ff6529",
    r: 256
  })), /*#__PURE__*/React.createElement("path", {
    d: "m502.688 324.608-205.308-205.308-169.14 273.4 119.14 119.14c2.863.095 5.734.16 8.62.16 117.618 0 216.697-79.326 246.688-187.392z",
    fill: "#e53b07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.38 119.3h-82.76l-86.38 273.4h60.83l20.5-64.9h92.86l20.5 64.9h60.83zm-69.49 150.5 28.11-88.96 28.11 88.96z",
    fill: "#f8fffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.38 119.3h-41.38v61.54l28.11 88.96h-28.11v58h46.43l20.5 64.9h60.83z",
    fill: "#d8d8d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabet);
export default __webpack_public_path__ + "static/media/alphabet.6981e521aeeb5ce186f779d4dd4cc51f.svg";
export { ForwardRef as ReactComponent };